import React, { Component } from 'react';
import { Input, Modal, message } from 'antd';
import API_URL from '../../../../common/url';
import AjaxRequest from '../../../../common/AjaxRequest';

const { TextArea } = Input;

class PMRefuse extends Component {
    state = {
        visible: false,
        loading: false,
        requirementId : '',
        reason : '',
        status:''
    }

    show = (requirementId,status) => {
        this.setState({
            visible: true,
            requirementId: requirementId || '',
            status
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    changeReason = e => {
        this.setState({ reason: e.target.value });
    }

    handleSubmit = () => {
        const { requirementId, reason, status } = this.state;
        
        if (!reason) {
            return message.warning("拒绝理由不能为空");
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.confirmPMHandoverReport,
            data: {
                status,
                staffHandoverId: requirementId,
                remark: reason,
                approveStatus: 'REJECT'
            },
            doneResult: res => {
                message.success('操作成功');
                this.setState({
                    visible : false,
                    loading: false,
                });
                this.props.reload();
            },
            errorResult: res => {
                this.setState({ loading: false });
            }
        };
        AjaxRequest.sendRequest(options);
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title='打回'
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width={400}
            >
                <div className="field-max">
                    <TextArea placeholder="请填写打回原因" value={this.state.reason} onChange={this.changeReason} rows={4} />
                </div>

            </Modal>
        );
    }
}

export default PMRefuse;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/PMRefuse.js